<template>
  <tr class="text txt-secondary">
    <td class="text-left">
      {{ computedTitle }}
    </td>

    <td class="text-right">{{ item.quantity }}</td>

    <td class="text-right">{{ item.costs }}</td>
  </tr>
</template>

<script>
export default {
  name: 'InformationItem',
  props: {
    title: {
      type: String,
      default: '',
    },

    item: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    computedTitle() {
      switch (this.item.name) {
        case 'marketing':
          return this.$t('CHATLYN_SUBSCRIPTION.INFORMATION.GENERAL.MARKETING');

        case 'service':
          return this.$t('CHATLYN_SUBSCRIPTION.INFORMATION.GENERAL.SERVICE');

        case 'utility':
          return this.$t('CHATLYN_SUBSCRIPTION.INFORMATION.GENERAL.UTILITY');

        default:
          return '---';
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
